<template>
  <div class="chip-margins">
    <v-chip v-for="chipConfig in chipsConfig" :key="chipConfig.groupCodeName" :width="defaultWidth"
            :color="chipConfig.color" :disabled="chipConfig.disabled" :style="getStyle(chipConfig.borderColor)"
            class="caption | d-flex justify-center align-center" :small="useSmallChips"
            @click="onClick(chipConfig.emitName, chipConfig.emitArgs)">{{ chipConfig.label }}</v-chip>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { MapGetters } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';

@Component
@MapGetters(['groupList'])
export default class ChipGroup extends Vue {
  @Prop({ type: Number, default: 50 }) defaultWidth;

  // List, object or any, that will be passed to parseGroupInfo, that must be implemented
  @Prop({ type: [Object, Array], required: true }) groupInfo;

  get useSmallChips() {
    return false;
  }

  get chipsConfig() {
    const groupInfoParsed = this.parseGroupInfo(this.groupInfo);
    return this.groupList.map((group) => {
      const { color, code_name: groupCodeName } = group;
      const groupLabel = groupInfoParsed[groupCodeName]?.label;
      const label = groupLabel || 'N/A';
      const emitName = groupInfoParsed[groupCodeName]?.emitName || 'click';
      const emitArgs = { groupCodeName, ...(groupInfoParsed[groupCodeName]?.emitArgs || {}) };
      const disabled = groupInfoParsed[groupCodeName]?.disabled || !groupLabel || false;
      const clickDisabled = groupInfoParsed[groupCodeName]?.clickDisabled || !groupLabel || false;
      const borderColor = groupInfoParsed[groupCodeName]?.borderColor || false;

      return {
        groupCodeName, label, color, emitName, emitArgs, disabled, clickDisabled, borderColor
      };
    });
  }

  getStyle(borderColor) {
    return {
      width: `${this.defaultWidth}px`,
      ...(borderColor && {
        borderColor,
        borderWidth: '2px',
        borderStyle: 'solid'
      })
    };
  }

  parseGroupInfo() {
    /* Expects the return of a dict with format
    {
      groupCodeName: {
        label: 'str',
        emitName: 'str', // default 'click'
        emitArgs: { groupCodeName } // default
        disabled: true/false // default false
        clickDisabled: true/false // default false
        borderColor: '#000' // to mark chip with a border color, undefined if none
      }
    }
    * */
    throw new Error('Not implemented');
  }

  onClick(emitName, emitArgs) {
    this.$emit(emitName, emitArgs);
  }
}
</script>

<style scoped lang="scss">
.chip-margins {
  * {
    margin: 2px 5px;
  }

  :first-child {
    margin: 2px 0;
  }

  :last-child {
    margin: 2px 0;
  }
}
</style>
